module.exports = __webpack_public_path__ + "img/base_divers_toilettes_public.dc35d937.svg";